import React from 'react'
import CIcon from '@coreui/icons-react'
import {
  cilBell,
  cilCalculator, cilChart,
  cilChartPie,
  cilCursor,
  cilDrop,
  cilNotes,
  cilPencil,
  cilPuzzle,
  cilSpeedometer,
  cilStar
} from "@coreui/icons";
import { CNavGroup, CNavItem, CNavTitle } from '@coreui/react'

const _nav = [
  {
    component: CNavItem,
    name: 'Dashboard',
    to: '/team/dashboard',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Club Leaderboard',
    to: '/team/club-leaderboard',
    icon: <CIcon icon={cilChart} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Team Leaderboard',
    to: '/team/team-leaderboard',
    icon: <CIcon icon={cilChart} customClassName="nav-icon" />,
  },

  {
    component: CNavGroup,
    name: 'Player',
    to: '/base',
    icon: <CIcon icon={cilPuzzle} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'All Players',
        to: '/team/player-all',
      },
      {
        component: CNavItem,
        name: 'Add Players',
        to: '/team/player-add',
      },
    ],
  },
]

export default _nav
